module.exports = __webpack_public_path__ + "static/media/12_720.99a6fd7f.jpeg";